/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, July 6th 2026, 1:06:27 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { EmphasisText, TextField, HelperText, OSAccordion } from "ui-widgets";

export const CronExpressionInput = (props: { label: string; setValue: (value: any) => void; value: string }) => {
  return (
    <>
      <TextField label={props.label} value={props.value} onChange={(event) => props.setValue(event.target.value)} />
      <OSAccordion
        mainSx={{ background: "rgba(var(--primary), 5%)" }}
        heading={<EmphasisText>Learn more about cron expressions</EmphasisText>}
      >
        <HelperText>
          Supported cron expressions are one of the below formats:
          <ul>
            <li>
              <span style={{ fontStyle: "italic" }}>minute hour day_of_month month day_of_week</span> e.g. 0 0 * * * for
              everyday at midnight
            </li>
            <li>
              <span style={{ fontStyle: "italic" }}>second minute hour day_of_month month day_of_week</span> e.g. 30 0 0
              * * * for everyday at midnight and 30 seconds
            </li>
            <li>
              <span style={{ fontStyle: "italic" }}>second minute hour day_of_month month day_of_week year</span> e.g.
              30 0 0 * * * 2027 for everyday at midnight and 30 seconds in the year 2027
            </li>
          </ul>
          Nonstandard predefined scheduling definitions (“@” keyword expressions) are also supported (
          <a
            href="https://en.wikipedia.org/wiki/Cron#Nonstandard_predefined_scheduling_definitions"
            target="_blank"
            rel="noreferrer"
          >
            Learn more
          </a>
          ):
          <ul>
            <li>
              <span style={{ fontStyle: "italic" }}>@midnight</span> - Everyday at midnight
            </li>
            <li>
              <span style={{ fontStyle: "italic" }}>@hourly</span> - Every hour
            </li>
            <li>
              <span style={{ fontStyle: "italic" }}>@daily</span> - Everyday
            </li>
            <li>
              <span style={{ fontStyle: "italic" }}>@weekly</span> - Every week
            </li>
            <li>
              <span style={{ fontStyle: "italic" }}>@monthly</span> - Every month
            </li>
            <li>
              <span style={{ fontStyle: "italic" }}>@yearly</span> - Every year
            </li>
          </ul>
        </HelperText>
      </OSAccordion>
    </>
  );
};
